import React from 'react';

import {AvatarTooltipWrapper} from 'components/dashboard/manager/nine-box/avatar/AvatarTooltipWrapper';
import {RepChartPoint} from '@store/@types/metric';
import {
  getHighlightQuadrant,
  shouldHighlightPoint,
} from 'components/dashboard/manager/nine-box/avatar/shouldHighlightPoint';
import {Moment} from 'moment';
import User, {UserId} from 'records/User';
import {KpiGoalPoint} from 'components/dashboard/manager/nine-box/one-rep-chart/KpiGoalPoint';
import {GraphGoal} from 'components/dashboard/manager/nine-box/NineBox.utils';
import {useState} from 'react';
import {Crosshairs} from './avatar/Crosshairs';

export interface MultiRepChartProps {
  onSelectRep: (rep: UserId | null) => void;
  chartData: RepChartPoint[];
  isCoachingZone: boolean;
  xGoal?: GraphGoal;
  yGoal?: GraphGoal;

  onCreatePlan: (rep: User) => void;
  startDate: Moment;
  endDate: Moment;
}

/**
 * An avatar scatter plot.
 * Given rep information and coordinates, plot their avatar on an x/y scatter plot grid.
 */
export const MultiRepChart: React.FC<MultiRepChartProps> = ({
  onSelectRep,
  isCoachingZone,
  chartData,
  onCreatePlan,
  startDate,
  endDate,
  xGoal,
  yGoal,
}) => {
  const [focusedData, setFocusedData] = useState<RepChartPoint>();
  const highlightQuadrant = getHighlightQuadrant(chartData.map(d => d.coordinate));

  return (
    <>
      <KpiGoalPoint xGoal={xGoal} yGoal={yGoal} />
      {chartData.map(data => (
        <AvatarTooltipWrapper
          key={data.rep.id}
          onClick={() => onSelectRep(data.rep.id)}
          highlight={
            isCoachingZone ? shouldHighlightPoint(data.coordinate, highlightQuadrant) : false
          }
          onCreatePlan={() => onCreatePlan(data.rep)}
          startDate={startDate}
          endDate={endDate}
          multiRepData={data}
          setCrosshair={show => setFocusedData(show ? data : undefined)}
        />
      ))}
      {focusedData && <Crosshairs data={{...focusedData.coordinate, ...focusedData.metricInfo}} />}
    </>
  );
};
